import React, { Component } from "react";
import Accounting_account from "../../../components/Accounting_account/Accounting_account";

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : AccountingForm
Description : Compoente que alberga el resto del formulario de registro definido en el directorio de componentes
Date Autor Modification
================================================================================
04/11/2021 Cristian Andres Pizo Mina – Se llama al componente de Accounting con sus respectivos parámetros.
================================================================================ */

class Accounting_accountForm extends Component{
    constructor(props){
        super(props);
    }
    render(){
        return(
            <Accounting_account/>
        )
    }
}

export default Accounting_accountForm;